/*eslint-disable */
// import QuizModel from '../../Model/Quiz'
import request from '../../Utils/curl'
let ChatBots = {
  /**
  * quizbotAskGpt
  */
  async quizbotAskGpt (context, payloadObj=null) {
    try {      
      let post_data = new FormData();

      if(payloadObj) {
        for (let key in payloadObj) {
          post_data.append(key, payloadObj[key])
        }
      }

      return await request.curl(context, "quizbot_ask_gpt", post_data)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at quizbotAskGpt() and Exception:",err.message)
    }    
  }
}

export { 
    ChatBots 
};
